module.exports = __webpack_public_path__ + "files/bb21f07e40706dbfd627ff8291667fea.png";